import { billingClient } from '#pplx_generated/typespec/rest/billing/client.js';
import { throttle } from 'lodash-es';
const UBB_CONFIG_FETCH_INTERVAL_MS = 60_000;
const fetchUbbConfig = async () => {
    const { data, error } = await billingClient.GET('/rest/billing/ubb-config', 'ubb-config-catalog', {
        timeoutMs: 5000,
    });
    if (error) {
        throw error;
    }
    return data;
};
export const getUbbConfig = throttle(fetchUbbConfig, UBB_CONFIG_FETCH_INTERVAL_MS, {
    leading: true,
    trailing: false,
});
//# sourceMappingURL=getUbbConfig.js.map